export function createRiskCaseClient(transport) {
    return {
        /**
         * List every tenant's risk cases, as identity and state
         *
         * Requires scope: risk-cases:platform:read
         */
        listPlatformRiskCases(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/risk-cases",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/risk-cases/source-events
         *
         * Requires scope: risk-cases:ingest
         */
        ingestRiskCaseSourceEvent(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases/source-events`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/risk-cases
         *
         * Requires scope: risk-cases:read
         */
        listRiskCases(tenantId, state, limit, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases`,
                query: { state: state, limit: limit },
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/risk-cases/{caseId}
         *
         * Requires scope: risk-cases:read
         */
        getRiskCase(tenantId, caseId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases/${encodeURIComponent(caseId)}`,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/risk-cases/{caseId}/evidence
         *
         * Requires scope: risk-cases:evidence:read
         */
        getRiskCaseEvidence(tenantId, caseId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases/${encodeURIComponent(caseId)}/evidence`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/risk-cases/{caseId}/transitions
         *
         * Requires scope: risk-cases:assign, risk-cases:close, risk-cases:investigate, risk-cases:resolve
         */
        transitionRiskCase(tenantId, caseId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases/${encodeURIComponent(caseId)}/transitions`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/risk-cases/evidence-retention/purge
         *
         * Requires scope: risk-cases:retention
         */
        purgeExpiredRiskCaseEvidence(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/risk-cases/evidence-retention/purge`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=risk-case.js.map